import { render, staticRenderFns } from "./SensorialEscolar.vue?vue&type=template&id=c80eb23a&scoped=true"
import script from "./SensorialEscolar.vue?vue&type=script&lang=js"
export * from "./SensorialEscolar.vue?vue&type=script&lang=js"
import style0 from "./SensorialEscolar.vue?vue&type=style&index=0&id=c80eb23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80eb23a",
  null
  
)

export default component.exports